import { expressionDefinitionApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const HALCYON_FORM_INCLUSION_SCHEMA_ACTION_TYPE = createNamedActions(
  'halcyonFormInclusionSchema',
  {
    GET_HALCYON_FORM_INCLUSION_SCHEMA: 'GET_HALCYON_FORM_INCLUSION_SCHEMA',
  },
);

export const getHalcyonFormInclusionSchemaAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await expressionDefinitionApi.getHalcyonFormInclusionExpressionDefinition();

  return dispatch({
    type: HALCYON_FORM_INCLUSION_SCHEMA_ACTION_TYPE.GET_HALCYON_FORM_INCLUSION_SCHEMA,
    payload: data,
  });
});
